/**
 * Submit recipe dialog — mockup-aligned modal from recipes browse.
 */
import React from 'react';
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { FaPlus } from 'react-icons/fa';
import { CommunityRecipeFormPanel } from './CommunityRecipeFormPanel';

export function SubmitRecipeModal({ show, onHide }) {
  const navigate = useNavigate();

  const handleSuccess = (recipeId) => {
    onHide();
    navigate(`/camp-essentials/recipes/${recipeId}`, { replace: true });
  };

  return (
    <Modal
      show={show}
      onHide={onHide}
      centered
      scrollable
      dialogClassName="camp-recipe-submit-modal"
      contentClassName="camp-recipe-submit-modal__content"
      data-testid="camp-recipe-submit-modal"
    >
      <Modal.Header closeButton className="camp-recipe-submit-modal__header">
        <Modal.Title className="camp-recipe-submit-modal__title">
          <FaPlus className="camp-recipe-submit-modal__title-icon" aria-hidden="true" />
          Submit a recipe
        </Modal.Title>
      </Modal.Header>
      <Modal.Body className="camp-recipe-submit-modal__body">
        <CommunityRecipeFormPanel onClose={onHide} onSuccess={handleSuccess} />
      </Modal.Body>
    </Modal>
  );
}
